const ddArray = document.querySelectorAll(`.drop-down__heading`);

const dropOnClick = (ddElement) => {
  const ddArrow = ddElement.querySelector(`.drop-down__arrow`);
  ddArrow.classList.toggle(`drop-down__arrow--dropped`);
  const ddContent = ddElement.nextElementSibling;
  ddContent.classList.toggle(`drop-down__content--hidden`);
};

ddArray.forEach((element) => {
  element.addEventListener(`click`, () => {
    dropOnClick(element);
  });
});